// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__xeW9d","orders__container":"Orders_orders__container__5fniu"};